module.exports = __webpack_public_path__ + "static/sala1-3718831b6824a19bd3c1e94e62374a1c.jpg";